import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "@/components/AuthLayout";
import { api, extractError } from "@/lib/api";
import { useI18n } from "@/contexts/LanguageContext";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(extractError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title={t("auth.forgot.title")} subtitle={t("auth.forgot.subtitle")} testId="forgot-page">
      {sent ? (
        <div className="space-y-6" data-testid="forgot-sent">
          <div className="nvl-card p-5 text-sm">{t("auth.forgot.sent")}</div>
          <Link to="/login" className="text-sm underline" data-testid="forgot-back-link">
            {t("auth.forgot.back")}
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-form">
          <div>
            <label htmlFor="forgot-email-input" className="text-xs uppercase tracking-widest" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
              {t("common.email")}
            </label>
            <input id="forgot-email-input"
              type="email"
              required
              className="nvl-input mt-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email-input"
            />
          </div>
          {error ? (
            <div className="text-sm" style={{ color: "hsl(var(--destructive))" }} data-testid="forgot-error">
              {error}
            </div>
          ) : null}
          <button
            type="submit"
            disabled={loading}
            className="nvl-btn nvl-btn-primary w-full disabled:opacity-60"
            data-testid="forgot-submit-button"
          >
            {loading ? t("common.loading") : t("auth.forgot.submit")}
          </button>
          <Link to="/login" className="text-sm underline" data-testid="forgot-back-link">
            {t("auth.forgot.back")}
          </Link>
        </form>
      )}
    </AuthLayout>
  );
}
